function isAllowed({
  permissions,
  permission,
}: {
  permissions: string[] | undefined;
  permission: string;
}) {
  return permissions?.includes(permission);
}

export default isAllowed;
